import {Component, computed, ElementRef, inject, signal, viewChild} from '@angular/core';
import {SelectionStore} from '../../selection.store';
import {SelectionItemComponent} from './selection-item/selection-item.component';
import {TitleCasePipe} from '@angular/common';

@Component({
  selector: 'app-selection-items',
  imports: [
    SelectionItemComponent,
    TitleCasePipe,
  ],
  templateUrl: './selection-items.component.html',
  styleUrl: './selection-items.component.css'
})
export class SelectionItemsComponent {
  readonly selectionStore = inject(SelectionStore);
  selected = signal<'good' | 'better' | 'best'>('good');

  scrollContainer = viewChild.required<ElementRef<HTMLElement>>('scrollContainer');

  scrollToTarget(key: 'good' | 'better' | 'best') {
    this.selected.set(key);
    const container = this.scrollContainer().nativeElement;
    const target = container.querySelector(`#${key}`) as HTMLElement;

    if (container && target) {
      container.scrollTo({left: target.offsetLeft, behavior: 'smooth'});
    }
  }

  readonly maxAddonRows = computed(() =>Math.max(0, ...this.selectionStore.grades().map(t => (t.data.addons?.addons ?? []).length)));

  readonly maxFeeRows = computed(() => Math.max(0, ...this.selectionStore.grades().map(t => (t.data.addons?.fees ?? []).length)));
}
